import Axios from "@/api/baseApi";

export default {
  addOrUpdate(items) {
    return Axios.post(`/api-registration/v1/piglet-orders`, items);
  },
  fetchByWeekId(weekId) {
    return Axios.get(`/api-registration/v1/piglet-orders/week/${weekId}`);
  },
  move(orderId, calendarWeekId) {
    return Axios.post(`/api-registration/v1/piglet-orders/move/${orderId}`, {calendarWeekId});
  },
  split(orderId) {
    return Axios.post(`/api-registration/v1/piglet-orders/split/${orderId}`);
  },
  remove(orderId) {
    return Axios.delete(`/api-registration/v1/piglet-orders/${orderId}`);
  }
}

